/**
 * Configuration for fields to omit from patch notes display.
 * 
 * Fields are specified using dot notation paths. Use wildcards (*) to match
 * array indices. For example:
 * - "weapons.*.ammo.staticAccuracyOverDistance" matches any weapon's ammo staticAccuracyOverDistance
 * - "fieldName" matches a top-level field exactly
 * 
 * Paths are matched against the actual field paths in the diff, which may include
 * array bracket notation like "weapons[0].ammo.fieldName".
 */
export const PATCH_NOTES_OMIT_FIELDS = [
  // Accuracy over distance arrays - these are large arrays that aren't useful in patch notes
  "weapons.*.ammo.staticAccuracyOverDistance",
  "weapons.*.ammo.movingAccuracyOverDistance",
  // Add more fields as needed
] as const;

export type PatchNotesOmitField = typeof PATCH_NOTES_OMIT_FIELDS[number];

